module.exports = __webpack_public_path__ + "img/linkwhite.83165bd7.svg";